export const addPrefix = (imageValule) => {
  if (imageValule?.startsWith("data:")) {
    return imageValule;
  }
  const mimeType = "image/png";
  const dataURI = `data:${mimeType};base64,${imageValule}`;
  return dataURI;
};
